/* eslint import/no-webpack-loader-syntax: 0 */

// This file attaches vendor files (core.js) to the window.
import "shared/modules/core-sample";

// if there's an npm module, prefer that
import jQuery from "jquery";
import React from "react";
import ReactDOM from "react-dom";
import TransitionGroup from "deprecated-react-transition-group/TransitionGroup";
import CSSTransitionGroup from "deprecated-react-transition-group/CSSTransitionGroup";
import moment from "moment";
import Spinner from "spin.js";
import Mousetrap from "mousetrap";
import classnames from "classnames";

import "redux";
import "react-redux";
import "redux-thunk";

window.Ok = window;
window.jQuery = jQuery;

// use require for these, since they need window.jQuery to be a thing
// and imports are done first one the page

/* eslint-disable import/no-unresolved */
require("imports-loader?this=>window!legacy/lib/modernizr-2.8.3.js");
require("imports-loader?jQuery=>window.jQuery!legacy/lib/chosen.jquery.js");
require("imports-loader?jQuery=>window.jQuery!legacy/lib/jquery.dotdotdot.js");
/* eslint-enable import/no-unresolved */

require("legacy/Cookies.js");

// add shit to the window
window.Spinner = Spinner;
window.Mousetrap = Mousetrap;
window.classnames = classnames;
window.moment = moment;
window.React = React;
window.React.addons = {
	TransitionGroup,
	CSSTransitionGroup,
};
window.ReactDOM = ReactDOM;



// WEBPACK FOOTER //
// ./src/bundles/vendor/index.js